// Smallest safe mechanism for "current screen" awareness in the AI Assistant.
// We remember the last app section the user visited (sessionStorage, tab-scoped)
// so the Assistant knows where the user came from. No routing changes.

const KEY = 'llos_last_screen';

const PATH_TO_SCREEN = [
  ['/dashboard', 'dashboard'],
  ['/goals', 'goals'],
  ['/tasks', 'tasks'],
  ['/projects', 'projects'],
  ['/finance', 'finance'],
  ['/habits', 'habits'],
  ['/review', 'review'],
  ['/settings', 'settings'],
];

export const screenFromPath = (pathname = '') => {
  const hit = PATH_TO_SCREEN.find(([prefix]) => pathname === prefix || pathname.startsWith(`${prefix}/`));
  return hit ? hit[1] : null;
};

export const rememberScreen = (pathname) => {
  const screen = screenFromPath(pathname);
  if (!screen) return;
  try {
    window.sessionStorage.setItem(KEY, screen);
  } catch (e) {
    // Storage may be unavailable (private mode); screen awareness is optional.
  }
};

export const getLastScreen = () => {
  try {
    return window.sessionStorage.getItem(KEY) || null;
  } catch (e) {
    return null;
  }
};

export const SCREEN_PATHS = {
  dashboard: '/dashboard',
  goals: '/goals',
  tasks: '/tasks',
  projects: '/projects',
  finance: '/finance',
  habits: '/habits',
  review: '/review',
  settings: '/settings',
};
